import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {Observable} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {Router} from '@angular/router';

import {environment} from '../../../environments/environment';
import {endpoints} from '../endpoints';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private usuario = '';
  private token = '';
  private loggedInStatus = false;
  private minutosAntesRefreshToken = environment.minutosAntesRefreshToken;
  private minutosAntesInterceptorRefreshToken = environment.minutosAntesInterceptorRefreshToken;

  constructor(private http: HttpClient,
              private router: Router) {
  }

  setUsuario(valor: string): any {
    this.usuario = valor;
  }

  getToken(): string {
    if (this.token === '') {
      this.token = localStorage.getItem('at');
    }

    return this.token;
  }

  setToken(valor: string): void {
    localStorage.setItem('at', valor);
    this.token = valor;
  }

  setLoggedIn(value: boolean): void {
    this.loggedInStatus = value;
  }

  getIsLoggedIn(): boolean {
    if (!this.loggedInStatus) {
      if (localStorage.getItem('at')) {
        // Se verifica vigencia de token
        const token = localStorage.getItem('at');
        const jwtToken = JSON.parse(atob(token.split('.')[1]));
        const expires = new Date(jwtToken.exp * 1000);
        const timeout = expires.getTime() - Date.now();

        if (timeout <= 0 || jwtToken?.ext === false) {
          this.loggedInStatus = false;
        } else {
          this.loggedInStatus = true;
        }
      }
    }

    return this.loggedInStatus;
  }

  iniciarSesion(correo: string, pass: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {
      correo,
      contrasena: pass
    };

    return this.http.post(endpoints.auth.login, JSON.stringify(parametros), {headers})
      .pipe(map((results: any) => {
        if (results.success) {
          if (results.data.code === 0) {
            localStorage.setItem('at', results.data.access_token);
          }
        }
        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  reiniciarPass(usuario: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {
      correo: usuario
    };

    return this.http.post(endpoints.auth.reiniciar, JSON.stringify(parametros), {headers})
      .pipe(map(results => {
        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  cambiarPass(usuario: string, pass: string, passNuevo: string, passConfirmacion: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {
      correo: usuario,
      contrasena: pass,
      nueva_contrasena: passNuevo,
      confirmar_nueva_contrasena: passConfirmacion
    };

    return this.http.post(endpoints.auth.cambiar, JSON.stringify(parametros), {headers})
      .pipe(map(results => {
        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  obtenerInformacionUsuario(): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {};

    return this.http.post(endpoints.auth.me, JSON.stringify(parametros), {headers})
      .pipe(map(results => {

        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  cerrarSesion(): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {};

    return this.http.post(endpoints.auth.logout, JSON.stringify(parametros), {headers})
      .pipe(map(results => {
        localStorage.clear();

        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  isLoggedInUser(): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.getToken()
      });

    const parametros = {};

    return this.http.post(endpoints.auth.me, JSON.stringify(parametros), {headers});
  }

  refreshToken(): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {};

    return this.http.post(endpoints.auth.refresh, JSON.stringify(parametros), {headers})
      .pipe(map((results: any) => {
        if (results.success) {
          if (results.data.code === 0) {
            localStorage.setItem('at', results.data.access_token);
          }
        } else {
          if (results.data.code === 42 || results.data.code === 99) {
            localStorage.setItem('msgty', 'login.warn.12');
            localStorage.setItem('msgti', 'Sesión expirada');
            localStorage.setItem('msgbo', 'La sesión del sistema ha expirado.');

            this.router.navigate(['/auth/login'], {queryParams: {skipUnsavedChangesGuard: true}});
          }
        }

        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  confirmUser(correo: string, codigo: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {
      correo,
      codigo
    };

    return this.http.post(endpoints.registro.confirmar, JSON.stringify(parametros), {headers})
      .pipe(map(results => {
        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  public verificarVencimientoToken(): number {
    const token = localStorage.getItem('at');

    let porExpirar = 0;
    if (token) {
      const jwtToken = JSON.parse(atob(token.split('.')[1]));
      const expires = new Date(jwtToken.exp * 1000);
      const timeout = expires.getTime() - Date.now();

      if (timeout > 0) {
        if (timeout < (Number(this.minutosAntesInterceptorRefreshToken) * 60 * 1000)) {
          porExpirar = 1;
        }
        if (timeout < (Number(this.minutosAntesInterceptorRefreshToken) * 60 * 1000) &&
          (timeout + 4000) >= (Number(this.minutosAntesRefreshToken) * 60 * 1000)) {
          porExpirar = 2;
        }
        if (timeout >= (Number(this.minutosAntesInterceptorRefreshToken) * 60 * 1000)) {
          porExpirar = 3;
        }
      } else {
        porExpirar = 4;
      }
    } else {
      porExpirar = 4;
    }

    return porExpirar;
  }

  public verificarAntesVencimientoToken(): boolean {
    const token = localStorage.getItem('at');
    const jwtToken = JSON.parse(atob(token.split('.')[1]));
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now();

    let porExpirar = false;
    if (timeout <= (Number(this.minutosAntesInterceptorRefreshToken) * 60 * 1000)) {
      porExpirar = true;
    }

    return porExpirar;
  }
}
